import React from 'react';
import { ImageProps } from '.';

const SvgKakaostyleOri = ({ size = 115, ...props }: ImageProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={(size && Math.floor(size / 4.791666666666667)) || 24}
      fill='none'
      viewBox='0 0 115 24'
      {...props}
    >
      <g clipPath='url(#KakaostyleOri_svg__a)'>
        <path
          fill='#FFCD00'
          d='m2.87 12.137 5.558 6.845 1.63-1.273-4.707-5.687 4.065-5.133-1.654-1.202-4.892 6.45ZM0 .785v17.872h2.112V.322L0 .785Z'
        />
        <path
          fill='#FFCD00'
          fillRule='evenodd'
          d='M11.929 15.26c0-1.28.425-2.255 1.275-2.926.85-.67 2.086-1.006 3.707-1.006h2.436v-.81c0-1.958-.858-2.936-2.573-2.936a7.007 7.007 0 0 0-1.733.232 9.806 9.806 0 0 0-1.665.577l-.62-1.503a8.562 8.562 0 0 1 2.034-.82 8.285 8.285 0 0 1 2.122-.29c2.971 0 4.456 1.595 4.455 4.786v8.093h-1.562l-.252-1.387a7.51 7.51 0 0 1-2.01 1.18c-.711.277-1.389.416-2.033.416-1.117 0-1.994-.32-2.629-.96-.635-.64-.952-1.522-.952-2.647Zm3.964 1.895c.304-.002.607-.04.902-.115.32-.08.633-.179.94-.299a5.179 5.179 0 0 0 1.612-1.018v-2.96h-2.196c-1.113 0-1.925.192-2.436.577-.51.385-.766.994-.765 1.827 0 1.325.647 1.988 1.943 1.988Z'
          clipRule='evenodd'
        />
        <path
          fill='#FFCD00'
          d='M25.127 18.657h2.112V.322l-2.112.463v17.873ZM34.541 6.89l-1.654-1.203-4.89 6.45 5.557 6.845 1.63-1.273-4.707-5.687 4.064-5.133Z'
        />
        <path
          fill='#FFCD00'
          fillRule='evenodd'
          d='M37.055 15.26c0-1.28.425-2.255 1.274-2.926.85-.67 2.086-1.006 3.709-1.006h2.433v-.81c0-1.958-.857-2.936-2.572-2.936a7.016 7.016 0 0 0-1.733.233 9.697 9.697 0 0 0-1.665.577l-.62-1.503a8.57 8.57 0 0 1 2.033-.82 8.288 8.288 0 0 1 2.124-.29c2.97 0 4.454 1.595 4.455 4.786v8.092H44.93l-.252-1.387a7.505 7.505 0 0 1-2.01 1.18c-.71.277-1.388.415-2.03.415-1.12 0-1.996-.32-2.63-.96-.635-.639-.953-1.521-.953-2.646Zm3.964 1.895c.305-.002.608-.04.904-.115.32-.08.633-.179.939-.299a5.13 5.13 0 0 0 1.61-1.019v-2.96h-2.195c-1.113 0-1.925.193-2.435.578-.51.385-.765.994-.766 1.827 0 1.325.648 1.988 1.943 1.988ZM59.102 7.513c-.995-1.14-2.365-1.71-4.11-1.71h-.002c-1.73-.002-3.095.568-4.098 1.71-1.002 1.142-1.503 2.777-1.503 4.904 0 2.096.499 3.707 1.494 4.832.994 1.125 2.364 1.688 4.11 1.688 1.759 0 3.133-.563 4.12-1.688.989-1.125 1.483-2.736 1.483-4.832-.001-2.129-.5-3.763-1.494-4.904Zm-6.649 1.249c.59-.833 1.435-1.249 2.537-1.249 1.118 0 1.972.416 2.561 1.249.59.832.884 2.05.884 3.653 0 1.587-.294 2.785-.884 3.595-.59.81-1.444 1.214-2.56 1.214-1.102 0-1.948-.406-2.538-1.214-.59-.809-.885-2.007-.885-3.595 0-1.603.296-2.821.885-3.653Z'
          clipRule='evenodd'
        />
        <path
          fill='#4D4D4D'
          d='M101.599 18.573h-3.236V.578L101.6 0v18.573ZM74.361 6.102l2.029-.24V3.302l3.283-.7V5.86h3.815v2.436h-3.815v5.525c0 1.978.507 2.34 1.451 2.34.652 0 1.376-.17 2.1-.434l.747 2.268c-.676.434-2.197.94-3.718.94-2.68 0-3.863-1.64-3.863-4.896V8.297H74.36V6.102ZM69.821 11.095c2.632.917 3.55 1.954 3.55 3.812 0 2.58-1.665 4.028-4.926 4.028-1.473 0-3.26-.338-4.684-.917l.652-2.509c1.28.483 2.68.845 4.008.845 1.352 0 1.835-.458 1.835-1.206s-.338-1.11-2.51-1.857c-2.61-.893-3.549-1.81-3.549-3.932 0-2.292 1.884-3.884 4.685-3.884 1.57 0 2.945.314 4.346.965l-.894 2.34c-.845-.458-2.148-.772-3.163-.772-1.207 0-1.883.53-1.883 1.327-.002.699.698 1.134 2.533 1.76ZM87.98 24c2.028-1.303 3.501-3.546 4.66-6.754l3.959-10.95-3.188-.917-2.873 10.034-2.897-10.01-3.211.868 4.491 12.374c-.748 1.375-1.569 2.315-2.945 3.521L87.98 24Z'
        />
        <path
          fill='#4D4D4D'
          fillRule='evenodd'
          d='M114.879 13.266c.076-.479.116-.962.121-1.447 0-4.052-1.908-6.344-5.311-6.344-3.501 0-5.699 2.485-5.699 6.73 0 4.414 2.101 6.73 6.374 6.73 1.426 0 3.332-.483 4.371-1.086l-.726-2.195c-.869.41-2.318.7-3.235.7-2.293 0-3.404-1.086-3.5-3.088h7.605Zm-3.02-2.194h-4.61c.049-2.003.87-3.16 2.341-3.16 1.593 0 2.269.989 2.269 3.16Z'
          clipRule='evenodd'
        />
      </g>
      <defs>
        <clipPath id='KakaostyleOri_svg__a'>
          <path fill='#fff' d='M0 0h115v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgKakaostyleOri;
